import angular from 'angular';
import { sqManualSignalService } from '@/hybrid/tools/manualSignal/manualSignal.utilities.service';

export default angular
  .module('Sq.ManualSignal', ['Sq.Investigate'])
  .service('sqManualSignalService', sqManualSignalService);
